<template>
  <div
    class="cursor-pointer"
    :class="open ? 'faq open' : 'faq'"
    @click="$emit('toggleOpen', index)"
  >
    <div class="question text-left font-semibold">
      <span class="mx-2">
        <i v-if="!open" class="fas fa-plus"></i>
        <i v-else class="fas fa-minus"></i></span
      >Module {{ index + 1 }}: {{ faq.title }}
    </div>
    <div class="answer">
      <span class="text-left tex">{{ faq.description }}</span>
      <hr />
      <div v-for="(lesson, i) in faq.lessons" :key="i">
        <div class=" my-2 mx-4 flex justify-between">
          <span class=""
            ><i v-if="lesson.lesson_type == 'article'" class="far fa-file "></i>
            <i v-if="lesson.lesson_type == 'video'" class="fas fa-video "></i>
            <i v-if="lesson.lesson_type == 'quiz'" class="fas fa-list-ul"></i>
            <i v-if="lesson.lesson_type == 'survey'" class="fas fa-poll"></i>
            <i
              v-if="lesson.lesson_type == 'exercise'"
              class="far fa-list-alt"
            ></i>
            {{ lesson.title }}</span
          >
          <span class="cursor-pointer" @click="navigate(lesson.id)"
            >View lesson</span
          >
        </div>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQ",
  props: ["faq", "index", "open"],
  methods: {
    navigate(lesson) {
      this.$router.push({
        name: "learner-lesson",
        params: { id: lesson },
      });
    },
  },
};
</script>
